import Vue from "vue"
import store from "../store"
import {locales} from "../settings"

Vue.mixin({
  methods: {
    locale(){
      return store.getters.getLocale;
    },
    t(key){
      let locale = this.locale();
      return locales[locale][key] || key;
    },
    T(key){
      return this.capitalize(this.t(key));
    },
    capitalize(string){
      if(typeof string!=='string') return '';
      return string.charAt(0).toUpperCase()+string.slice(1);
    },
    shorten(str, maxLen, separator = ' ') {
      if(str===undefined){
        return 'undefined'
      }

      if(str===null){
        return ''
      }



      if (str.length <= maxLen) return str;
      return str.substr(0, str.lastIndexOf(separator, maxLen))+'...';
    }
  }
})
